/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentConfirmationStep_form$ref: FragmentReference;
declare export opaque type DevelopmentConfirmationStep_form$fragmentType: DevelopmentConfirmationStep_form$ref;
export type DevelopmentConfirmationStep_form = {|
  +id: string,
  +hasLandForSale: ?boolean,
  +developmentProduct: ?{|
    +id: string,
    +slug: string,
    +title: ?string,
  |},
  +$refType: DevelopmentConfirmationStep_form$ref,
|};
export type DevelopmentConfirmationStep_form$data = DevelopmentConfirmationStep_form;
export type DevelopmentConfirmationStep_form$key = {
  +$data?: DevelopmentConfirmationStep_form$data,
  +$fragmentRefs: DevelopmentConfirmationStep_form$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentConfirmationStep_form",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLandForSale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentProduct",
      "kind": "LinkedField",
      "name": "developmentProduct",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentRegistrationForm",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f124b30dcc60082d60f5c39d189858f2';

export default node;
